import React from 'react';
import { PropertiesList } from '../../models/propertyModel';

type Props = {
  property: PropertiesList;
};

const getRentaStyle = () => ({
  color: '#17a2b8',
  fontWeight: 600,
});

const getVentaStyle = () => ({
  color: '#6f42c1',
  fontWeight: 600,
});

const getStatusLabel = (status?: string) => {
  if (status === 'created') return 'Creado';
  if (status === 'published') return 'Publicado';
  if (status === 'sold_external') return 'Vendido externamente';
  if (status === 'disabled') return 'Desactivado';
  return status || '';
};

const formatDate = (dateStr?: string | null) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const PropertyStatusDetail: React.FC<Props> = ({ property }) => (
  <div>
    {getStatusLabel(property.state) && (
      <div>
        Estado de Renta:
        <span style={getRentaStyle()}>
          {` ` + getStatusLabel(property.state)}
        </span>
        <span style={{ marginLeft: 8, fontSize: 13, color: '#6c757d', fontWeight: 500 }}>
          {formatDate(property.for_rent_published_at)}
        </span>
      </div>
    )}
    {getStatusLabel(property.sale_state) && (
      <div>
        Estado de Venta:
        <span style={getVentaStyle()}>
          {` ` + getStatusLabel(property.sale_state)}
        </span>
        <span style={{ marginLeft: 8, fontSize: 13, color: '#6c757d', fontWeight: 500 }}>
          {formatDate(property.for_sale_published_at)}
        </span>
      </div>
    )}
  </div>
);

export default PropertyStatusDetail;